import React, { forwardRef } from 'react';
import cx from 'classnames';
import AvatarIcon from './components/AvatarIcon';
import { hasIconType, } from './types';
import styles from './Avatar.module.scss';
/**
 * The Avatar component is typically a visual representation of a user, displayed as an image or icon, often accompanied by the user's initials.
 * @type React.ForwardRefRenderFunction<HTMLDivElement, AvatarPropTypes>
 */
const Avatar = forwardRef(({ alt, className, color = 'blue', icon, iconType, initials, size = 'md', src, ...rest }, ref) => {
    let content;
    if (src) {
        content = React.createElement("img", { alt: alt, className: styles.image, src: src });
    }
    else if (hasIconType({ iconType, icon })) {
        // TypeScript knows icon and iconType are defined here due to the type guard
        content = (React.createElement(AvatarIcon, { ...{ icon, iconType }, size: size }));
    }
    else if (initials) {
        content = initials;
    }
    if (!content) {
        return null;
    }
    const colorClass = initials ? styles[color] : styles.default;
    const sizeClass = styles[size];
    const cn = cx(styles.avatar, colorClass, sizeClass, className);
    return (React.createElement("div", { className: cn, ref: ref, ...rest }, content));
});
export default Avatar;
